import { Type } from '@angular/core';
import { ActivatedRouteSnapshot, Event } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, startWith } from 'rxjs/operators';
import { resolveRouteComponentSelector, RouteComponentSelector } from './route-component-selector';
import { routerActivationEndForComponent } from './router-activation-end-for-component';

type EntityIdParser = ((value: string) => string) | ((value: string) => number);

export function routerCurrentChildEntityId(
  currentRoute: ActivatedRouteSnapshot,
  childComponentType: Type<unknown> | RouteComponentSelector,
  parser: EntityIdParser = (value: string) => value,
  idParamName = 'id'
) {
  const isChildComponentRoute = resolveRouteComponentSelector(childComponentType);
  const idParamSelector = (snapshot: ActivatedRouteSnapshot) => snapshot.paramMap.get(idParamName) ?? null;

  const initialRoutedPage = currentRoute.firstChild;
  const initialRawEntityId =
    initialRoutedPage && isChildComponentRoute(initialRoutedPage) ? idParamSelector(initialRoutedPage) : null;

  return (source$: Observable<Event>) =>
    source$.pipe(
      routerActivationEndForComponent(childComponentType),
      map(({ snapshot }) => idParamSelector(snapshot)),
      startWith(initialRawEntityId),
      map(id => (id !== null ? parser(id) : id)),
      distinctUntilChanged(),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
}
